const module = [
  {
    id: '2f942795-13c7-46c9-965e-4760885a20bf',
    slug: 'mlp-directors-officers-cover',
    visible: true,
    requiresAuth: false,
    showFeedbackForm: true,
    concatenatedID: '2f942795-13c7-46c9-965e-4760885a20bf|f698ff3b-eb6f-4635-8f7e-a81c6d3f69ae',
    template: 'video-template',
    title: 'MLP - Directors and Officers cover',
    description:
      'Learn about MLP Directors & Officers policy/cover available, key risks and underwriting considerations.',
    completedDescription: 'TODO',
    supplier: 'AXA Broker Development',
    categoryId: 'f698ff3b-eb6f-4635-8f7e-a81c6d3f69ae',
    questionnaireId: '0c624416-354e-4179-86e9-1081192bbbbc',
    contents: {
      id: '93aa5acd-055b-4880-930e-09bbca167bfd',
      longDescription:
        '<h2 class="subtitle">Description</h2>' +
        'Learn about MLP Directors & Officers policy/cover available, key risks and underwriting considerations.' +
        // '<h2 class="subtitle">Objectives</h2>' +
        // '<ul style="margin-top:10px">' +
        // '<li>Thing_1</li>' +
        // '<li>Thing_2</li>' +
        // '<li>Thing_3</li>' +
        // '</ul>',
        '',
      heroImage: false,
      media: [
        {
          type: 'video',
          subType: 'vimeo',
          title: 'MLP - Directors and Officers cover.',
          button: '',
          fileSize: 0,
          url: 'https://player.vimeo.com/video/{{video id}}',
          caption: {
            title: '',
            description:
              '<p>Delivered by: AXA Commercial</p>' + '<p>Brought to you by: AXA Commercial.</p>'
          }
        },
        {
          type: 'file',
          subType: 'pdf',
          title: 'MLP - Directors and Officers cover.',
          button: 'Download Slides',
          fileSize: '3191102',
          url: 'mlp-directors-officers-cover.pdf',
          caption: {
            title: '',
            description: ''
          },
          axaUrl: ''
        }
      ]
    },
    progress: {
      value: 2,
      maximum: 5
    },
    statistics: {
      level: 0,
      timeEstimate: '10'
    },
    status: {
      state: 'not-started',
      completedDate: ''
    },
    tags: ['sales', 'marketing', 'products', 'foundation']
  }
];

export const MlpDirectorsOfficersCover = {
  module
};
